import React from 'react';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {prizeInfo, coursePrize, refundPolicy, priceGroup} from './data';
import {Container} from '../../../Components/Atom';

const Award = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '기부마라톤']} />
			{/* <CardSection {...prizeInfo} />
			<CardSection {...refundPolicy} />
			<CardSection {...coursePrize} />
			<CardSection {...priceGroup} /> */}
		</Container>
	);
};

export default Award;
